module.exports = __webpack_public_path__ + "static/img/fj-image.115ab573.jpg";